<script setup>
import { Check, Video, Users, GraduationCap } from 'lucide-vue-next'

defineProps({
  planNumber: {
    type: Number,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  features: {
    type: Array,
    required: true
  },
  color: {
    type: String,
    default: 'blue'
  }
})

const icons = {
  video: Video,
  users: Users,
  graduate: GraduationCap
}

const colorConfig = {
  blue: {
    badge: 'bg-blue-600',
    icon: 'from-blue-500 to-blue-600',
    check: 'bg-blue-100 text-blue-600',
    border: 'hover:border-blue-500'
  },
  purple: {
    badge: 'bg-purple-600',
    icon: 'from-purple-500 to-purple-600',
    check: 'bg-purple-100 text-purple-600',
    border: 'hover:border-purple-500'
  },
  green: {
    badge: 'bg-green-600',
    icon: 'from-green-500 to-green-600',
    check: 'bg-green-100 text-green-600',
    border: 'hover:border-green-500'
  }
}
</script>

<template>
  <div :class="['bg-white rounded-3xl p-6 md:p-10 shadow-lg hover:shadow-2xl transition-all border-2 border-gray-200 transform hover:-translate-y-1 relative', colorConfig[color].border]">
    <div :class="['absolute -top-4 left-8 text-white px-4 py-1 rounded-full text-sm font-bold', colorConfig[color].badge]">
      Plan {{ planNumber }}
    </div>
    <div :class="['w-16 h-16 bg-gradient-to-br rounded-2xl flex items-center justify-center mb-6', colorConfig[color].icon]">
      <component :is="icons[color === 'blue' ? 'video' : color === 'purple' ? 'users' : 'graduate']" class="text-white w-8 h-8" />
    </div>
    <h3 class="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-6">{{ title }}</h3>
    <p class="text-sm md:text-base text-gray-600 leading-relaxed md:mb-8">{{ description }}</p>
    <div class="space-y-4 hidden md:block">
      <div v-for="(feature, index) in features" :key="index" class="flex items-center space-x-3">
        <div :class="['w-6 h-6 rounded-full flex items-center justify-center shrink-0', feature.isHighlight ? 'bg-blue-100' : colorConfig[color].check.split(' ')[0]]">
          <component
            :is="feature.icon === 'video' ? Video : Check"
            :class="['w-3 h-3', feature.isHighlight ? 'text-blue-600' : colorConfig[color].check.split(' ')[1]]"
          />
        </div>
        <p class="text-gray-700">{{ feature.text }}</p>
      </div>
    </div>
  </div>
</template>
